import { Card, SimpleGrid, VStack } from "@chakra-ui/react";

import { ContributionTiers } from "./ContributionTiersTable";
import { Top100Banner } from "./GuardiansLeaderboard";
import { GuardiansUserProfile } from "./GuardiansUserProfile";
import { Hero } from "./Hero";

import { BodyText } from "@/components/body-text";
import { HeaderText } from "@/components/header-text";
import { NavButton } from "@/components/nav-button";
import { AppRoute } from "@/constants/shared";

const transactionExamples = [
  {
    title: "Daily Spin",
    description: "Spin the wheel once a day for rewards",
    ctaText: "Try your luck",
    ctaLink: AppRoute.DailySpin,
  },
  {
    title: "Level Up",
    description:
      "Complete quests, learn about Plume, earn yields and Plume Points!",
    ctaText: "Explore Quests",
    ctaLink: AppRoute.Quests,
  },
  {
    title: "Discover",
    description:
      "Discover Apps on Plume - stake, lend, borrow, loop, earn and more!",
    ctaText: "Discover Apps",
    ctaLink: AppRoute.Apps,
  },
];

export const GuardiansOfPlume = () => {
  return (
    <VStack w="full" gap={8} alignItems="start">
      {/* hero */}
      <Hero />
      {/* connect wallet banner */}
      <GuardiansUserProfile />
      {/* Contribution Tiers table */}
      <ContributionTiers />
      {/* Leaderboard Table */}
      <Top100Banner />
      {/* <GuardiansLeaderboard /> */}
      {/* Stack your transactions section */}
      <VStack alignItems="start" w="full">
        <HeaderText>Stack your transactions</HeaderText>
        <BodyText fontFamily="heading">
          A few ideas to kick things off but any transaction counts, so play
          your way.
        </BodyText>
        <SimpleGrid columns={[1, 1, 1, 1, 3]} gap={6} mt={4} w="full">
          {transactionExamples.map(
            ({ title, description, ctaText, ctaLink }) => (
              <Card.Root rounded="3xl" key={title}>
                <Card.Body>
                  <BodyText color="fg" fontSize="xl" fontFamily="heading">
                    {title}
                  </BodyText>
                  <BodyText fontFamily="heading">{description}</BodyText>
                </Card.Body>
                <Card.Footer>
                  <NavButton href={ctaLink}>{ctaText}</NavButton>
                </Card.Footer>
              </Card.Root>
            ),
          )}
        </SimpleGrid>
      </VStack>
    </VStack>
  );
};
